import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';
import { getRcaInvestigationData, type InvestigationData } from './getRcaInvestigationData.tsx';

// Sentinel value the incident page appends to investigationUrl when it opens
// the analysis page in a known-completed state. Allows the resource to skip
// thinking_steps in the initial fetch for faster initial paint.
const INCIDENT_COMPLETED_SOURCE = 'incident-completed';

export const rcaInvestigationResource: RouteResource<InvestigationData> =
	createResource<InvestigationData>({
		type: 'RCA_INVESTIGATION_RESOURCE',
		// Direct navigation keeps the original `investigation-<id>` shape so
		// pre-existing cached entries survive this change. Only when source
		// is present do we append it, which prevents the from-incident fetch
		// (with thinking_steps potentially skipped) from colliding with a
		// direct-visit fetch.
		getKey: ({ match, query }) =>
			query.source
				? `investigation-${match.params.id}-${query.source}`
				: `investigation-${match.params.id}`,
		getData: ({ match, query }, { tenantContext }) => {
			const investigationId = match.params.id;

			if (!investigationId) {
				throw new Error('Investigation ID is required to fetch RCA investigation ');
			}

			return getRcaInvestigationData(
				tenantContext.cloudId,
				investigationId,
				undefined,
				// Only skip thinking_steps when the incident page hinted at a
				// completed-state navigation AND the optimization gate is on.
				// fg() is kept inline (no const alias) to satisfy
				// jira/ff/inline-usage.
				query.source !== INCIDENT_COMPLETED_SOURCE ||
					!fg('rca_skip_thinking_steps_from_incident_panel'),
			);
		},
		isBrowserOnly: true,
	});
